import React, { Component } from 'react';
import { Spin, Table, Tooltip, Button, Card, Icon, InputNumber, Col, Row, Modal, Select, Pagination, Badge, Popover, Alert } from 'antd';
import { sanitizerTexto, getStatusInv, getStatusInvColor, esBorradorVencido } from '../../util/utilerias';
import { openNotification } from '../../util/notificaciones';
import CatalogoRequest from '../../services/Catalogo';
import { get_id } from '../../util/IdUser';
import InventarioBarrasRequest from '../../services/InventarioBarras';
import VistaInventarioBarras from './VistaInventarioCiclico';
import { roles } from '../../util/Roles';
import moment from 'moment';
import Timer from '../Timer/Timer';
import { withRouter } from "react-router";
import { Link } from 'react-router-dom';
import { esBarras, getSegmento } from '../../util/generics';
import InventarioCiclicoRequest from '../../services/InventarioCiclico';
import { Diario, DIAS_SEMANA, Semanal } from '../../constants';
moment.locale('es')
const rol = localStorage.getItem("role")?.split(",");
const { confirm } = Modal;
const { Option } = Select

/**
 * Evento para cancelar el scroll en input number
 */
document.addEventListener("wheel", function (event) {
    if (document.activeElement.type === "number") {
        document.activeElement.blur();
    }
});

/**
 * Clase para ver el proceso de mostrar artículos del inventario
 */
export default class ListaInventariosCiclicos extends Component {
    state = {
        esBarra: esBarras(),
        tienePendientes: false,
        diaSemana: null,
        arrListaInventario: [],
        filterText: "",
        cargando: false,
        bloquear_diario: true,
        bloquear_semanal: true,
        arrDrives: [],
        driveSelected: undefined,
        scroll: { x: 1050, y: 500 },
        disable_combo_drive: false,
        mostrar_modal_articulos: false,
        arr_articulos_error: [],
        mostrar_variacion: false,
        paginacion: {},
        pageSize: 100,
        totalArticulos: 0,
        FechaStr: ""
    }

    /**
     * Comportamiento del componente al mostrar los artículos
     */
    componentDidMount = () => {
        let state = { ...this.state };
        const segmento = getSegmento()
        if (!segmento || !state.esBarra) {
            const location = {
                pathname: "/",
            }
            this.setState(state, this.props.history.push(location))
        } else {
            const script = document.createElement("script");
            script.src = "https://kit.fontawesome.com/a076d05399.js";
            script.async = true;
            script.crossorigin = 'anonymous';
            document.body.appendChild(script);

            CatalogoRequest.CargarSitiosByUsuario(get_id()).then(response => {
                state.arrDrives = response.data
                let fecha = new Date();
                fecha.setHours(fecha.getHours());
                state.FechaStr = fecha.toLocaleDateString();
                this.setState(state, () => {
                    if (response.data.length === 1) {
                        this.setState({ driveSelected: response.data[0].id }, this.onChangeDrive)
                    } else {
                        let elSitio = response.data.find((item) => item.id == (this.props.match.params.idSitio * 1));
                        if (elSitio != undefined) {
                            this.setState({ driveSelected: (this.props.match.params.idSitio * 1) }, this.onChangeDrive);
                        }
                    }
                    if (!response.data.length) {
                        if (rol.includes(roles.Operador)) {
                            openNotification(
                                "El usuario no tiene asignada una barra, favor de contactar al Administrador.",
                                "Error"
                            )
                        } else {
                            openNotification(
                                "El usuario no tiene asignada una barra, deberá configurarla en el módulo de usuarios.",
                                "Aviso"
                            )
                        }
                    }
                })
            }).catch(err => {
                openNotification(
                    "Ha ocurrido un error al listar las barras del usuario.",
                    "Error"
                )
            })
        }
    }

    componentWillReceiveProps(props) {
        //this.componentDidMount();
    }

    /**
     * Función para obtener el rango de la semana en base a la fecha enviada
     */
    obtenerSemana = (fecha = new Date()) => {
        const d = new Date(fecha);
        d.setHours(0, 0, 0, 0);

        //Se obtiene el número del día de la semana: 0 domingo, 1 lunes, ..., 6 sábado
        const dia = d.getDay();
        const diffToMonday = (dia === 0 ? -6 : 1 - dia); // si es domingo, retrocede 6 días

        const inicio = new Date(d);
        inicio.setDate(d.getDate() + diffToMonday);
        inicio.setHours(0, 0, 0, 0);

        const final = new Date(inicio);
        final.setDate(inicio.getDate() + 6);
        final.setHours(23, 59, 59, 999);

        return { inicio, final };
    }

    /**
     * Función para determinar si una fecha está dentro del rango proporcionado
     */
    fechaEnRango = (fecha, inicio, fin) => {
        const t = fecha.getTime();
        return t >= inicio.getTime() && t <= fin.getTime();

    }

    /**
     * Se ejecuta cuando se cambia un drive
     */
    onChangeDrive = () => {
        let state = { ...this.state };
        this.setState({ cargando: true }, () => {
            if (state.driveSelected) {
                InventarioCiclicoRequest.ListaInventarios(state.driveSelected).then(response => {
                    if (!response.data.results.length) {
                        const diaActual = new Date().getDay()
                        state.arrListaInventario = []
                        state.cargando = false
                        state.bloquear_diario = false
                        state.bloquear_semanal = false

                        //Se revisa si estamos en el día límite para capturar inventario semanal
                        if (diaActual === DIAS_SEMANA.Domingo || diaActual === DIAS_SEMANA.Sabado) {
                            state.tienePendientes = true
                            state.diaSemana = diaActual
                        }

                        this.setState(state);
                        openNotification(
                            "No se han encontrado inventarios para la barra seleccionada.",
                            "Error"
                        )
                    } else {
                        state.paginacion = {
                            current: 1,
                            total: response.data.count,
                            onChange: this.handlePaginaChange,
                            pageSize: 100,
                            showTitle: false
                        }
                        state.bloquear_diario = false;
                        state.bloquear_semanal = false;
                        state.cargando = false;

                        const hoy = new Date();
                        const diaSemana = hoy.getDay() //Obtiene qué día es hoy
                        hoy.setHours(0, 0, 0, 0);

                        const { inicio, final } = this.obtenerSemana(hoy)

                        response.data.results.forEach((item) => {
                            const fechaItem = new Date(item.Fecha)
                            fechaItem.setHours(fechaItem.getHours() + 7)

                            item.Fecha2 = new Date(item.Fecha)
                            item.Fecha2.setHours(item.Fecha2.getHours() + 7)

                            item.FechaStr = fechaItem.toLocaleDateString()

                        })

                        //Busca el inventario semanal de la semana actual
                        const semanal = response.data.results.find((item) => {
                            const itemDate = new Date(item.Fecha)
                            return (itemDate >= inicio && itemDate <= final) && item.Frecuencia === Semanal
                        })

                        //Revisa si no hay inventario semanal en la semana actual y si el día es domingo
                        if (!semanal && (diaSemana === DIAS_SEMANA.Domingo || diaSemana === DIAS_SEMANA.Sabado)) {
                            state.tienePendientes = true
                            state.diaSemana = diaSemana
                        }

                        state.arrListaInventario = response.data.results;
                        state.disableRange = false;
                        this.setState(state)
                    }
                }).catch(err => {
                    this.setState({ cargando: false });
                    openNotification(
                        "Ha ocurrido un error al listar el histórico del drive seleccionado.",
                        "Error"
                    )
                })
            } else {
                state.cargando = false;
                state.paginacion.total = 0;
                state.arrListaInventario = [];
                state.disableRange = true;
                state.dateStrings = [];
                state.fecha_historico = [];
                this.setState(state)
            }
        })
    }

    /**
     * Mostrarl el modal de formulario de inventario
     * @param: type. acción que elige el usuario entre ver o editar
     * @param: record. objecto de inventario seleccionado
     * @return: nada, se usa el valor para mostrar datos específicos
     */
    showForm = (type, _, record) => {
        this.setState({ typeForm: type, objInventario: record, visible: true })
    }

    /**
     * Función para esconder modal de detalle de inventario
     * @param: value. true o false
     * @return: nada
     */
    esconderModal = (value) => {
        let state = { ...this.state }
        state.visible = false;
        state.objInventario = null;
        this.setState(state, () => {
            if (value) this.onChangeDrive()
        })
    }

    deleteInv = (record) => {
        let state = { ...this.state };
        this.setState({ cargando: true }, () => {
            InventarioCiclicoRequest.EliminarBorrador(record.id).then(response => {
                state.paginacion = {
                    current: 1,
                    total: response.data.count,
                    onChange: this.handlePaginaChange,
                    pageSize: 100,
                    showTitle: false
                }

                let nuevosInventarios = state.arrListaInventario.filter(i => i.id != record.id)

                state.bloquear_diario = false;
                state.bloquear_semanal = false

                const hoy = new Date();
                hoy.setHours(0, 0, 0, 0);

                nuevosInventarios.find((item) => {
                    const fechaItem = new Date(item.Fecha)
                    fechaItem.setHours(fechaItem.getHours() + 7)

                    item.Fecha2 = new Date(item.Fecha)
                    item.Fecha2.setHours(item.Fecha2.getHours() + 7)

                    item.FechaStr = fechaItem.toLocaleDateString()

                });

                state.cargando = false;
                state.arrListaInventario = nuevosInventarios
                // state.disableRange = false;
                this.setState(state)
            }).catch(err => {
                this.setState({ cargando: false });
                console.log(err)
                openNotification(
                    "Ha ocurrido un error al eliminar el inventario. Favor de intentarlo más tarde",
                    "Error"
                )
            })
        })
    }

    showConfirm = (value) => {
        confirm({
            title: 'Confirmar Eliminar',
            content: <div><b>¿Está seguro de eliminar este registro?</b></div>,
            okText: 'Aceptar',
            cancelText: 'Cancelar',
            okButtonProps: {
                id: 'boton-aceptar-confirmacion-capturar-inventario-form',
            },
            cancelButtonProps: {
                id: 'boton-cancelar-confirmacion-capturar-inventario-form',
            },
            onOk: () => {
                this.deleteInv(value)
            },
        });
    }

    render() {
        const columnasInventario = [
            {
                title: "Fecha y hora de captura",
                dataIndex: "Fecha2",
                key: "Fecha2",
                render: fecha => {
                    return (
                        <span>
                            {moment(fecha).format("DD/MM/YYYY, h:mm a")}
                        </span>
                    )
                }
            },
            {
                title: "Usuario que capturó",
                dataIndex: "usuario",
                key: "usuario",
                render: usuario => {
                    return (
                        <span>
                            {usuario}
                        </span>
                    )
                }
            },
            {
                title: "Estado",
                dataIndex: "Estatus",
                key: "Estatus",
                render: (value, record) => {
                    return (
                        <span style={{ fontWeight: "bold", color: getStatusInvColor(value) }}> {getStatusInv(value)}</span>
                    )
                }
            },
            {
                title: "Cíclico",
                dataIndex: "Frecuencia",
                key: "Frecuencia",
                render: Frecuencia => {
                    return (
                        <span style={{ fontWeight: 'bold' }}>
                            {Frecuencia === 1 ? 'Diario' : 'Semanal'}
                        </span>
                    )
                }
            },
            {
                title: 'Acciones',
                dataIndex: 'Acciones',
                key: 'Acciones',
                render: (value, record) => (
                    <div>
                        <span style={{ marginRight: 5 }}>
                            <Tooltip placement="top" title={"Ver detalle de inventario"}>
                                <Button icon="eye" className="btnVerCrearGuardar" onClick={() => this.showForm('detalle', value, record)}></Button>
                            </Tooltip>
                        </span>
                        <span style={{ marginRight: 5 }}>
                            <Tooltip placement="top" title={"Editar inventario"}>
                                <Link to={`/editarCiclico/${this.state.driveSelected}/${record.id}/${record.Frecuencia}`}>
                                    <Button icon="edit" className="btnEditar" disabled={(record.Estatus != 0 && record.Estatus != 1 && record.Estatus != 2) || esBorradorVencido(record.Fecha)}></Button>
                                </Link>
                            </Tooltip>
                        </span>

                        {(record.Estatus === 0 || record.Estatus === 1 || record.Estatus === 2) &&
                            <span style={{ marginRight: 5 }}>
                                <Tooltip placement="top" title={"Eliminar"}>
                                    <Button icon="delete" className="btnEditar" onClick={() => this.showConfirm(record)}></Button>
                                </Tooltip>
                            </span>
                        }
                    </div>
                )
            }
        ]

        return (
            <Card id="ParentSize"
                title={'Captura de inventario cíclico'}
                extra={
                    <Row gutter={[8, 8]}>
                        <Col span={12}>
                            <Link to={`/nuevoCiclico/${this.state.driveSelected}/1`}>
                                <Button
                                    className="btnVerCrearGuardar"
                                    disabled={this.state.bloquear_diario}
                                    type="primary"
                                    id="boton-guardar-inventario-modulo"
                                > Agregar diario</Button>
                            </Link>
                        </Col>
                        <Col span={12}>
                            <Link to={`/nuevoCiclico/${this.state.driveSelected}/2`}>
                                <Button
                                    className="btnVerCrearGuardar"
                                    disabled={this.state.bloquear_semanal}
                                    type="primary"
                                    id="boton-guardar-inventario-modulo"
                                >Agregar Semanal</Button>
                            </Link>
                        </Col>
                    </Row>
                }
            >
                <div className="panel-block">
                    <div style={{ marginBottom: "20px" }}>
                        <Row gutter={24}>
                            <Col span={8}>
                                <Tooltip placement="top" title="Barra">

                                    <div className="center">Barra:</div>

                                    <Select
                                        defaultActiveFirstOption={false}
                                        allowClear={this.state.arrDrives?.length > 1}
                                        showSearch
                                        disabled={this.state.disable_combo_drive}
                                        notFoundContent={"No hay opciones"}
                                        style={{ width: "100%" }}
                                        placeholder="Seleccionar..."
                                        optionFilterProp="children"
                                        filterOption={(input, option) => sanitizerTexto(input, option.props.children)}
                                        value={this.state.driveSelected}
                                        onChange={(value) => {
                                            this.setState({ driveSelected: value }, this.onChangeDrive)
                                        }}
                                    >
                                        <Option key={0} value={null} disabled={true}>Seleccionar...</Option>
                                        {
                                            this.state.arrDrives?.length > 0 &&
                                            this.state.arrDrives.map((obj, index) => {
                                                return (
                                                    <Option
                                                        key={obj.id}
                                                        value={obj.id}>
                                                        {obj.nombre}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Tooltip>
                            </Col>
                            {this.state.tienePendientes && <Col offset={4} span={12}>
                                <Alert
                                    message="No se ha capturado inventario semanal"
                                    description={`${this.state.diaSemana == DIAS_SEMANA.Sabado ? 'Mañana' : 'Hoy'} es el último día para capturar el inventario semanal.`}
                                    type={this.state.diaSemana == DIAS_SEMANA.Sabado ? 'warning' : 'error'}
                                />
                            </Col>}
                        </Row>
                    </div>
                    {<Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.cargando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                        <Table size="small"
                            locale={{ emptyText: 'No se han encontrado resultados' }}
                            rowKey={(_, index) => index}
                            columns={columnasInventario}
                            dataSource={this.state.arrListaInventario}
                            pagination={this.state.paginacion}
                        />
                    </Spin>}
                </div>
                <VistaInventarioBarras
                    esconderModal={this.esconderModal}
                    visible={this.state.visible}
                    type={this.state.typeForm}
                    inventario={this.state.objInventario}
                    drive_selected={this.state.driveSelected}
                    esExterno={this.props.match.params.esExterno}
                />

            </Card>
        )
    }


}